import React, { Component } from 'react';
import { RootPropsContext } from './root-props-context';

type RootProps = React.ContextType<typeof RootPropsContext>;

export const withRootProps = <P,>(WrappedComponent: React.ComponentType<P>) => {
  class WithRootProps extends Component<P> {
    render() {
      return (
        <RootPropsContext.Provider value={this.props as P & RootProps}>
          <WrappedComponent {...this.props} />
        </RootPropsContext.Provider>
      );
    }
  }

  return WithRootProps;
};
